<h2 mat-dialog-title>{{ 'UPDATE_DOCUMENTS' | transloco }}</h2>
<mat-dialog-content>
  <form [formGroup]="indexerForm">
    @for (field of archiveFields; track field.id) {
      @if (field.multiValue) {
        <div class="field-container">
          <app-multi-value-field
            [field]="field"
            [form]="getMultiValueFormArray(field.id)"
            [addRequiredValidator]="false"
          ></app-multi-value-field>
          <mat-slide-toggle (change)="onClearToggleChange($event, field)"
            ><span transloco="CLEAR"></span
          ></mat-slide-toggle>
        </div>
      } @else {
        <div class="field-container">
          <app-field
            [field]="field"
            [form-control]="getFormControl(field.id)"
            [addRequiredValidator]="false"
          ></app-field>
          <mat-slide-toggle (change)="onClearToggleChange($event, field)"
            ><span transloco="CLEAR"></span
          ></mat-slide-toggle>
        </div>
      }
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  @if (showSaveProgressBar()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <button mat-button mat-dialog-close>
    {{ 'CANCEL' | transloco }}
  </button>
  <span class="spacer"></span>
  <button mat-button [disabled]="disableSave" (click)="onSave()">
    {{ 'SAVE' | transloco }}
  </button>
</mat-dialog-actions>
